
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { Alert } from "../../addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  import FormEspecialidad from "./Form.vue"
  
  @Component({
    name: "ProductosIndex",
    components: {FormEspecialidad}
  })
  export default class EspecialidadIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    datos2 = [];
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
		swForm = false;
		especialidad_selected = {}
    get especialidades(): any {
      return this.consultorioStore.especialidades;
    }
    
    public txtSearch = "";
    swEditar = false
    mounted(){
      this.getEspecialidades();
    }
    getEspecialidades(){
      this.consultorioService.getEspecialidades()
    }

    get especialidadesFilter(): any {
      let data = this.especialidades;
      if(this.txtSearch != ''){
        return data.filter(val => val.nombre.toUpperCase().includes(this.txtSearch.toUpperCase()))
      }
      return data;
    }
    nuevaEspecialidad(){
			this.swForm = true;
			this.swEditar = false;

    }
    editar(especialidad:any){
			this.swForm = true;
			this.swEditar = true;
			this.especialidad_selected = especialidad
      
    }
   
    close(){
        this.swForm = false;
    }
    
    get pagination(): any {
      return this.consultorioStore.pagination;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  